export * from './IconLentaStroked';
